import { useEffect, useRef } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useResumePayment } from './CreditsDialogContext'
import { parseTransactionId } from './lib/parseTransactionId'

/**
 * Сюда воронка возвращает вкладку после оплаты кредитов — и при успехе, и при
 * отказе (api, `BuyService`, `path_success`/`path_fail`). На других адресах
 * `tx` не читается.
 */
const RETURN_PATH = '/settings/balance'

/**
 * Вкладка, вернувшаяся из воронки, показывает тот же экран ожидания, что и
 * исходная: галочку с суммой или крест. `tx` убирается из адреса сразу — F5
 * не должен снова поднимать диалог давно закрытой покупки.
 *
 * Гард по значению `tx`, а не по монтированию: `resumePayment` — новая ссылка
 * на каждом рендере провайдера, и без гарда эффект заводил бы наблюдение
 * повторно, в том числе после того, как автор закрыл диалог.
 */
export const PaymentReturn = () => {
  const { pathname } = useLocation()
  const [params, setParams] = useSearchParams()
  const resumePayment = useResumePayment()
  const handled = useRef<string | null>(null)
  const raw = pathname === RETURN_PATH ? params.get('tx') : null

  useEffect(() => {
    if (raw === null || handled.current === raw) return
    handled.current = raw
    const id = parseTransactionId(raw)
    if (id !== null) resumePayment(id)
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev)
        next.delete('tx')
        return next
      },
      { replace: true },
    )
  }, [raw, resumePayment, setParams])

  return null
}
